export const MEDIA_SECTION_YOUTUBE_VIDEO_ID = 'l8JlLiGEpfE';
